import { mdTable } from '@shared/utils/markdown-export.utils';

/*
 * Pure Markdown-bouwstenen voor planeetstanden, los van HdExportPlanetsService zodat de
 * Markdown-builders zonder Angular-afhankelijkheden blijven.
 */

/** Eén planeetrij in een Markdown-export ("Transit op dat moment"). */
export interface MdPlanetRow {
  readonly name: string;
  /** `poort.lijn`, bv. `50.3`. */
  readonly value: string;
  readonly retrograde: boolean;
}

export interface MdPlanetLabels {
  readonly planet: string;
  readonly gateLine: string;
  readonly retrograde: string;
}

/** Planeetstanden als Markdown-tabel (planeet | poort.lijn | ℞); leeg zonder rijen. */
export function planetsMarkdown(rows: readonly MdPlanetRow[], labels: MdPlanetLabels): string {
  if (rows.length === 0) return '';
  return mdTable(
    [labels.planet, labels.gateLine, labels.retrograde],
    rows.map(row => [row.name, row.value, row.retrograde ? '℞' : '']),
  );
}
